<template>
  <div class="section" id="password-chage">
      <div class="columns is-flex-direction-column">
        <div class="column is-half-desktop is-offset-one-quarter-desktop"
        >
          <h1 class="subtitle">パスワード変更</h1>
          <b-field label="現在のパスワード">
            <b-input type="password" password-reveal></b-input>
          </b-field>
          <b-field label="新しいパスワード" message="※英数字8文字以上で設定してください">
            <b-input type="password" password-reveal></b-input>
          </b-field>
          <b-field label="新しいパスワード（再入力）" message="※英数字8文字以上で設定してください">
            <b-input type="password" password-reveal></b-input>
          </b-field>
          <div class="formbutton">
            <b-button type="is-primary">
              変更する
            </b-button>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordChange'
};
</script>

<style lang="scss" scoped>
  @import '../assets/scss/passwordchange.scss';
</style>
